<div class="revenue-page">
    <!-- =========================================================
       HEADER
  ========================================================== -->

    <div class="revenue-header">
        <div>
            <div class="page-eyebrow">OWNER REPORT</div>

            <h1>Revenue Report</h1>

            <p>Day book, OPD, IPD and doctor-wise revenue collection</p>
        </div>

        <div class="header-actions">
            <button
                type="button"
                class="export-btn excel-btn"
                [disabled]="loading || exportingExcel"
                (click)="exportExcel()"
            >
                <i class="fa fa-file-excel"></i>

                {{ exportingExcel ? "Exporting..." : "Export Excel" }}
            </button>

            <button type="button" class="export-btn pdf-btn" [disabled]="loading || exportingPdf" (click)="exportPdf()">
                <i class="fa fa-file-pdf"></i>

                {{ exportingPdf ? "Generating..." : "Export PDF" }}
            </button>
        </div>
    </div>

    <!-- =========================================================
       HOSPITAL INFO
  ========================================================== -->

    <div class="hospital-strip">
        <div class="hospital-icon">
            <i class="fa fa-hospital"></i>
        </div>

        <div>
            <strong> {{ hospitalName || "Hospital" }} </strong>

            <span> {{ hospitalAddress }} </span>
        </div>
    </div>

    <!-- =========================================================
       REPORT TYPE
  ========================================================== -->

    <div class="report-tabs">
        <button
            type="button"
            *ngFor="let tab of reportTabs"
            class="report-tab"
            [class.active]="activeCategory === tab.value"
            (click)="setCategory(tab.value)"
        >
            {{ tab.label }}
        </button>
    </div>

    <!-- =========================================================
       FILTER CARD
  ========================================================== -->

    <div class="filter-card">
        <div class="filter-group">
            <label> From Date </label>

            <input type="date" [(ngModel)]="fromDate" (change)="onDateChange()" />
        </div>

        <div class="filter-group">
            <label> To Date </label>

            <input type="date" [(ngModel)]="toDate" (change)="onDateChange()" />
        </div>

        <div class="filter-group doctor-filter" *ngIf="doctorOptions.length > 0">
            <label> Doctor </label>

            <select [(ngModel)]="selectedDoctor" (change)="onDoctorFilterChange()">
                <option value="ALL">All Doctors</option>

                <option *ngFor="let doctor of doctorOptions" [value]="doctor">{{ doctor }}</option>
            </select>
        </div>

        <div class="filter-group search-filter">
            <label> Search </label>

            <div class="search-input">
                <i class="fa fa-search"></i>

                <input
                    type="text"
                    [(ngModel)]="searchText"
                    (input)="applyFilters()"
                    placeholder="Patient, invoice or doctor"
                />
            </div>
        </div>

        <div class="filter-actions">
            <button type="button" class="view-report-btn" (click)="loadReport()">
                <i class="fa fa-filter"></i>

                View Report
            </button>

            <button type="button" class="clear-btn" (click)="clearFilters()">Clear</button>
        </div>
    </div>

    <!-- =========================================================
       KPI
  ========================================================== -->

    <div class="revenue-kpis">
        <div class="revenue-kpi total-kpi">
            <div class="kpi-icon">₹</div>

            <div>
                <span> Total Revenue </span>

                <strong> {{ summary.totalRevenue | currency: "INR": "symbol": "1.0-2" }} </strong>

                <small> {{ summary.totalPatients }} receipts </small>
            </div>
        </div>

        <div class="revenue-kpi opd-kpi">
            <div class="kpi-icon">
                <i class="fa fa-user-md"></i>
            </div>

            <div>
                <span> OPD Revenue </span>

                <strong> {{ summary.opdRevenue | currency: "INR": "symbol": "1.0-2" }} </strong>

                <small> {{ summary.opdPatients }} patients </small>
            </div>
        </div>

        <div class="revenue-kpi ipd-kpi">
            <div class="kpi-icon">
                <i class="fa fa-bed"></i>
            </div>

            <div>
                <span> IPD Revenue </span>

                <strong> {{ summary.ipdRevenue | currency: "INR": "symbol": "1.0-2" }} </strong>

                <small> {{ summary.ipdPatients }} patients </small>
            </div>
        </div>

        <div class="revenue-kpi doctor-kpi">
            <div class="kpi-icon">
                <i class="fa fa-stethoscope"></i>
            </div>

            <div>
                <span> Doctors </span>

                <strong> {{ summary.doctorCount }} </strong>

                <small> Revenue contributors </small>
            </div>
        </div>
    </div>

    <!-- =========================================================
       LOADER
  ========================================================== -->

    <div class="report-loader" *ngIf="loading">
        <div class="spinner"></div>

        <span> Loading revenue report... </span>
    </div>

    <!-- =========================================================
       DOCTOR SUMMARY
  ========================================================== -->

    <div
        class="report-card"
        *ngIf="
      !loading &&
      activeCategory === 'DOCTOR' &&
      doctorSummary.length > 0
    "
    >
        <div class="report-card-header">
            <div>
                <h3>Doctor Revenue Summary</h3>

                <p>Doctor-wise collections for selected period</p>
            </div>
        </div>

        <div class="table-scroll">
            <table class="revenue-table">
                <thead>
                    <tr>
                        <th>Sr No.</th>

                        <th>Doctor</th>

                        <th>Patients</th>

                        <th>OPD</th>

                        <th>IPD</th>

                        <th class="amount-column">Total Received</th>
                    </tr>
                </thead>

                <tbody>
                    <tr
                        *ngFor="
              let doctor of doctorSummary;
              let i = index
            "
                    >
                        <td>{{ i + 1 }}</td>

                        <td>
                            <div class="doctor-cell">
                                <div class="doctor-avatar">
                                    <i class="fa fa-user-md"></i>
                                </div>

                                <strong> {{ doctor.doctorName || "Not Assigned" }} </strong>
                            </div>
                        </td>

                        <td>{{ doctor.patientCount }}</td>

                        <td>{{ doctor.opdCount }}</td>

                        <td>{{ doctor.ipdCount }}</td>

                        <td class="revenue-value">{{ doctor.totalReceived | currency: "INR": "symbol": "1.0-2" }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>

    <!-- =========================================================
       DAY BOOK
  ========================================================== -->

    <div
        class="report-card"
        *ngIf="
      !loading &&
      filteredRows.length > 0
    "
    >
        <div class="report-card-header">
            <div>
                <h3>Revenue Day Book</h3>

                <p>Patient-wise received payment report</p>
            </div>

            <div class="report-count">
                {{ filteredRows.length }} {{ filteredRows.length === 1 ? "record" : "records" }}
            </div>
        </div>

        <div class="table-scroll">
            <table class="revenue-table">
                <thead>
                    <tr>
                        <th>Sr No.</th>

                        <th>Date</th>

                        <th>Invoice No.</th>

                        <th>Patient Name</th>

                        <th>Category</th>

                        <th>Doctor Referred</th>

                        <th>Payment Mode</th>

                        <th class="amount-column">Total Received</th>
                    </tr>
                </thead>

                <tbody>
                    <tr
                        *ngFor="
              let row of paginatedRows;
              let i = index
            "
                    >
                        <td>{{ (pageNo - 1) * pageSize + i + 1 }}</td>

                        <td>
                            <div class="date-cell">{{ row.receivedDate | date: "dd MMM yyyy" }}</div>
                        </td>

                        <td>
                            <span class="invoice-number"> {{ row.invoiceNumber }} </span>
                        </td>

                        <td>
                            <div class="patient-cell">
                                <div class="patient-avatar">{{ row.patientName .charAt(0) .toUpperCase() }}</div>

                                <strong> {{ row.patientName }} </strong>
                            </div>
                        </td>

                        <td>
                            <span
                                class="patient-type-pill"
                                [class.opd]="row.patientType === 'OPD'"
                                [class.ipd]="row.patientType === 'IPD'"
                            >
                                {{ row.patientType === "OPD" ? "OPD" : "IPD" }}
                            </span>
                        </td>

                        <td>
                            <div class="doctor-name">
                                <i class="fa fa-user-md"></i>

                                {{ row.doctorName || "-" }}
                            </div>
                        </td>

                        <td>
                            <span class="payment-mode"> {{ row.paymentMode || "-" }} </span>
                        </td>

                        <td class="revenue-value">{{ row.totalReceived | currency: "INR": "symbol": "1.0-2" }}</td>
                    </tr>
                </tbody>

                <tfoot>
                    <tr>
                        <td colspan="7">Total Received</td>

                        <td class="grand-total">{{ summary.totalRevenue | currency: "INR": "symbol": "1.0-2" }}</td>
                    </tr>
                </tfoot>
            </table>
        </div>

        <!-- =====================================
         PAGINATION
    ====================================== -->

        <div class="pagination-wrapper">
            <div class="pagination-info">
                Showing

                <strong> {{ startRecord }} </strong>

                to

                <strong> {{ endRecord }} </strong>

                of

                <strong> {{ filteredRows.length }} </strong>

                records

                <select [value]="pageSize" (change)="onPageSizeChange($event)">
                    <option *ngFor="let size of pageSizeOptions" [value]="size">{{ size }} / page</option>
                </select>
            </div>

            <div class="pagination-buttons" *ngIf="totalPages > 1">
                <button type="button" [disabled]="pageNo === 1" (click)="goToPage(pageNo - 1)">
                    <i class="fa fa-chevron-left"></i>
                </button>

                <button
                    type="button"
                    *ngFor="let page of visiblePageNumbers"
                    [class.active]="pageNo === page"
                    (click)="goToPage(page)"
                >
                    {{ page }}
                </button>

                <button type="button" [disabled]="pageNo === totalPages" (click)="goToPage(pageNo + 1)">
                    <i class="fa fa-chevron-right"></i>
                </button>
            </div>
        </div>
    </div>

    <!-- =========================================================
       EMPTY
  ========================================================== -->

    <div
        class="empty-report"
        *ngIf="
      !loading &&
      filteredRows.length === 0
    "
    >
        <div class="empty-icon">
            <i class="fa fa-file-invoice-dollar"></i>
        </div>

        <h3>No revenue records found</h3>

        <p>No paid transactions are available for the selected report period.</p>
    </div>
</div>
